import { render, staticRenderFns } from "./NotificationModal.vue?vue&type=template&id=ae4b3cd8&scoped=true&"
import script from "./NotificationModal.vue?vue&type=script&lang=ts&"
export * from "./NotificationModal.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationModal.vue?vue&type=style&index=0&id=ae4b3cd8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4b3cd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
